"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopicBlock = void 0;
var _react = _interopRequireDefault(require("react"));
require("../cdn.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const TopicBlock = exports.TopicBlock = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    tag = "h2",
    image,
    alt = "",
    label = "",
    title,
    separator = "auto",
    gap = 5,
    text,
    children,
    className = "",
    reversed = false,
    imageContained = false,
    source = ""
  } = _ref;
  const Header = tag;
  const showSeparator = separator === true || separator === "auto" && title && (text || children);
  let imageContainer = /*#__PURE__*/_react.default.createElement("img", {
    src: image,
    alt: alt,
    className: "topic-block-image"
  });
  if (imageContained || source) {
    imageContainer = /*#__PURE__*/_react.default.createElement("div", {
      className: ["flex", "content-center", "flex-col", "flex-basis-50"].filter(v => !!v).join(" ")
    }, imageContainer, source && /*#__PURE__*/_react.default.createElement("p", {
      className: "text-right w-full px-8 px-sm-7"
    }, source));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: ["topic-block", reversed && "topic-block-reverse", ...className.split(" ")].filter(v => !!v).join(" "),
    ref: ref
  }, imageContainer, /*#__PURE__*/_react.default.createElement("div", {
    className: ["topic-block-content"].filter(v => !!v).join(" ")
  }, label && /*#__PURE__*/_react.default.createElement("strong", null, label), title && /*#__PURE__*/_react.default.createElement(Header, {
    className: "fs-h1"
  }, title), showSeparator && /*#__PURE__*/_react.default.createElement("hr", null), text && /*#__PURE__*/_react.default.createElement("p", {
    className: "fs-h3"
  }, text), children && /*#__PURE__*/_react.default.createElement("div", {
    className: ["flex", Array.isArray(children) && "flex-wrap gap-".concat(gap)].filter(v => !!v).join(" ")
  }, children)));
});